import heic2any from 'heic2any';

// export const convertHeicToJpeg = async (heic: File) => {
//   const jpeg = await heic2any({
//     blob: new Blob([heic], { type: heic.type }),
//     toType: 'image/jpeg',
//     quality: 0.8,
//   });
//   return new File([jpeg as BlobPart], heic.name.replace('.heic', '.jpg'));
// };

export const convertHeicToJpeg = async (heicOrHeifFile: File) => {
  const jpeg = await heic2any({
    blob: new Blob([heicOrHeifFile], { type: heicOrHeifFile.type }),
    toType: 'image/jpeg',
    quality: 0.8,
  });

  // 正規表現を使って拡張子を汎用的に置換します
  const newName = heicOrHeifFile.name.replace(/\.(heic|heif)$/i, '.jpg');
  return new File([jpeg as BlobPart], newName, { type: 'image/jpeg' });
};
